const Page = (props) => (
	
	<div className={`print-page ${props.className}`} style={props.style}>
		{ props.children }
	</div>
);

export default Page;
